import { StateCreator } from 'zustand'
import { OrganizationType } from '@/shared/types'
import { type CampaignCreationState, initialOrganization } from '../state'

export interface Step7Slice {
    organization: OrganizationType
    setOrganization: (organization: OrganizationType) => void
    handleOrganizationTypeSelect: (option: {
        value: string
        label: string
    }) => void
    handleInputChange: (field: keyof OrganizationType, value: string) => void
    handleToggle: () => void
}

export const createStep7Slice: StateCreator<
    CampaignCreationState,
    [],
    [],
    Step7Slice
> = (set) => ({
    organization: initialOrganization,
    setOrganization: (organization) => set({ organization }),
    handleOrganizationTypeSelect: (option) =>
        set((state) => ({
            organization: { ...state.organization, type: option.label },
        })),
    handleInputChange: (field, value) =>
        set((state) => ({
            organization: { ...state.organization, [field]: value },
        })),
    handleToggle: () =>
        set((state) => ({
            organization: {
                ...state.organization,
                isFinalAdvertiser: !state.organization.isFinalAdvertiser,
            },
        })),
})
